export const ORGANIZATION_FIELD_HELP = {
  name: 'Display name shown in the org switcher, admin panel, and invitation emails. 2–120 characters.',
  slug: 'URL-safe identifier. Lowercase letters, digits, and hyphens only. Must start and end with a letter or digit. Cannot be changed after creation.',
  plan: 'Subscription tier. free = default limits; standard = expanded limits; enterprise = custom contract. Changing plan here is a superadmin override — does not trigger billing.',
  status: 'active = normal operation; suspended = members cannot log in; archived = read-only, cannot add new members.',
  logoUrl:
    'Public URL for the org logo shown in the switcher and invitation emails. Must be https://. Leave empty to use the default icon.',
  founderEmail:
    'Email address of the first org admin. They will receive an invitation link to sign up and claim the org_admin role.',
  founderRole: 'Role assigned to the founder on invitation acceptance. Fixed to org_admin.',
  features:
    'Per-org feature flags. Changes take effect after clicking Save. Each flag controls a specific platform capability.',
  modules:
    "Industry modules enabled for this org. core is always present. Additional modules (finance, etc.) extend the org's available tools and pages.",
} as const;
